/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Returned_AmountInputs */

const vi_order_returned_amount = /** @type {(inputs: Order_Returned_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã trả hàng`)
};

/**

* @param {Order_Returned_AmountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_returned_amount = /** @type {((inputs?: Order_Returned_AmountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Returned_AmountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_returned_amount(inputs)
});